import { render } from "./OurServicePage.vue?vue&type=template&id=0a8a6d8c&scoped=true"
import script from "./OurServicePage.vue?vue&type=script&lang=js"
export * from "./OurServicePage.vue?vue&type=script&lang=js"

import "./OurServicePage.vue?vue&type=style&index=0&id=0a8a6d8c&lang=less&scoped=true"
import "./OurServicePage.vue?vue&type=style&index=1&id=0a8a6d8c&lang=less&scoped=true"
import "./OurServicePage.vue?vue&type=style&index=2&id=0a8a6d8c&lang=less&scoped=true"
import "./OurServicePage.vue?vue&type=style&index=3&id=0a8a6d8c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8a6d8c"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QParallax from 'quasar/src/components/parallax/QParallax.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QParallax,QImg,QSeparator});
